<template>
  <div id="download">
    <NavigationBar />

    <div class="uk-section uk-section-muted" v-if="!loading">
      <div class="uk-container" v-if="data != null">
        <h2 class="uk-text-bold uk-text-center">
          Download File - {{ data.name }}
        </h2>
        <div class="uk-width-1-1" v-if="!isSmall">
          <div uk-grid class="uk-flex uk-flex-right">
            <router-link to="/e-garansi" class="uk-button uk-button-primary"
              >Create E-garansi</router-link
            >
          </div>
          <table class="uk-table uk-table-striped uk-hover">
            <thead>
              <tr>
                <th><b>Filename</b></th>
                <th><b>Version</b></th>
                <th><b>Update Date</b></th>
                <th><b>Option</b></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(detail, index) in data.details" :key="index">
                <td>{{ detail.name }}</td>
                <td>{{ detail.version }}</td>
                <td>{{ detail.updated_date_file }}</td>
                <td>
                  <a
                    :href="detail.url_download"
                    target="_blank"
                    @click="downloaded(detail)"
                    >Download</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <div class="uk-width-1-1 uk-margin-bottom">
            <router-link to="/e-garansi" class="uk-button uk-button-primary uk-width-1-1"
              >Create E-garansi</router-link
            >
          </div>
          <div
            class="uk-width-1-1 uk-margin-bottom"
            v-for="(detail, index) in data.details"
            :key="index"
          >
            <div class="uk-card uk-card-default uk-card-body">
              <h5 class="uk-text-bold">{{ detail.name }}</h5>
              <p>
                Version: {{ detail.version }} <br />
                Date Update: {{ detail.updated_date_file }}
              </p>
              <p>
                <a
                  :href="detail.url_download"
                  target="_blank"
                  @click="downloaded(detail)"
                >
                  Download
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-container" v-else>
        <h2 class="uk-text-bold uk-text-center">Not Found!</h2>
      </div>
    </div>
    <div v-else class="uk-section" style="height: 70vh">
      <div class="uk-container" style="height: 100%">
        <div class="uk-flex uk-flex-center uk-flex-middle" style="height: 100%">
          <div uk-spinner></div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import axios from "axios";

export default {
  name: "download",
  components: {
    NavigationBar,
    Footer,
  },
  data() {
    return {
      data: null,
      loading: true,
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    seo_url() {
      return this.$route.params.seo_url;
    },
    isSmall() {
      return window.innerWidth < 960;
    },
  },
  methods: {
    getData() {
      this.loading = true;
      this.data = null;
      axios
        .get(
          `${
            process.env.VUE_APP_API_ROOMI_URL
          }files/${this.seo_url.toLowerCase()}`
        )
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            const data = res.data;
            if (data.success) {
              this.data = data.data;
              document.title = `Download File ${this.data.name} - Roomi`;
            }
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    downloaded(detail) {
      axios.patch(
        `${
          process.env.VUE_APP_API_ROOMI_URL
        }files/${this.seo_url.toLowerCase()}/${detail.id}`
      );
    },
  },
};
</script>

<style scoped>
ul.app-desc {
  padding-left: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
  line-height: 1;
  width: 50%;
}

ul.app-desc li {
  padding: 2.5px 0;
  text-transform: capitalize;
  color: rgb(164, 173, 184);
  word-spacing: 2px;
  font-weight: 300;
  letter-spacing: 1.5px;
}

ul.app-desc li::after {
  content: "|";
  margin-left: 5px;
  margin-right: 5px;
}

ul.app-desc li:last-child::after {
  content: "";
}

/* ul.uk-slider-items li img {
	height: 200px;
} */

.card-download {
  cursor: pointer;
}

.card-download:hover {
  box-shadow: 0 5px 15px rgb(0 0 0 / 25%) !important;
}

@media screen and (max-width: 639px) {
  .text-container > * {
    text-align: center;
  }

  ul.app-desc {
    margin: auto;
    display: inline-block;
    width: 100%;
  }

  ul.app-desc li a {
    text-align: center;
  }

  ul.app-desc li::after {
    content: "";
  }
}
</style>